export const config = {
  baseUrlApi: process.env.REACT_APP_API_BASEURL,
};
export default config;
